export const WhyUsData = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // style="vertical-align: -0.125em;"
        width="1em"
        height="1em"
        // preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 20 20"
      >
        <path
          //   fill="currentColor"
          d="M11.3 2.48a3.5 3.5 0 0 0-2.6 0L2.943 4.785A1.5 1.5 0 0 0 2 6.176v7.646a1.5 1.5 0 0 0 .943 1.393L8.7 17.518c.1.04.2.075.303.105A2.542 2.542 0 0 1 9 17.5v-.94l-5.686-2.273A.5.5 0 0 1 3 13.822V6.238l6.5 2.6v3.161a2.509 2.509 0 0 1 1-.792v-2.37L17 6.239V9.5a2.5 2.5 0 0 1 .958 1.542l.042.008V6.176a1.5 1.5 0 0 0-.943-1.392L11.3 2.48Zm-2.228.93a2.5 2.5 0 0 1 1.857 0l5.225 2.09l-2.279.91l-6.154-2.46l1.35-.54ZM6.375 4.487l6.154 2.461L10 7.961L3.846 5.499l2.529-1.011ZM12 11.999v-.5a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 1.5 1.5v.5h.5a1.5 1.5 0 0 1 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5a1.5 1.5 0 0 1 1.5-1.5h.5Zm3.5-1h-2a.5.5 0 0 0-.5.5v.5h3v-.5a.5.5 0 0 0-.5-.5Zm1.5 5.5V16h2v1.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0Z"
        />
      </svg>
    ),
    heading: "Modern equipment",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut dolore facilisis.",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        // preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 20 20"
      >
        <path
          //   fill="currentColor"
          d="M12.158 2.974a.5.5 0 0 0-.316-.948c-.938.312-1.523 1.082-1.866 1.907a5.288 5.288 0 0 0-.128.339a3.998 3.998 0 0 0-.71-.963a3.99 3.99 0 0 0-2.94-1.17a1.09 1.09 0 0 0-1.06 1.059a3.99 3.99 0 0 0 1.17 2.94l.032.03A4.002 4.002 0 0 0 3.198 9.76l-.006.074a8.5 8.5 0 0 0 1.01 4.748l.359.658c.01.017.02.034.032.05l1 1.402a2.685 2.685 0 0 0 4.084.338a.456.456 0 0 1 .645 0a2.685 2.685 0 0 0 4.084-.338l1-1.401a.51.51 0 0 0 .033-.051l.358-.658a8.5 8.5 0 0 0 1.011-4.748l-.006-.074a4 4 0 0 0-4.644-3.626L10.5 6.41c.01-.681.13-1.447.398-2.093c.281-.675.697-1.155 1.26-1.343Zm-5.25 6a1.22 1.22 0 0 0-.716.605c-.186.348-.312.922-.195 1.859a.5.5 0 0 1-.993.124c-.132-1.064-.009-1.865.306-2.454c.32-.6.807-.924 1.282-1.083a.5.5 0 0 1 .317.949Z"
        />
      </svg>
    ),
    heading: "Healthy nutition Plan",
    details:
      "Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.",
  },

  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        // preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        <path
          //   fill="currentColor"
          d="M12 5c-1.11 0-2 .89-2 2s.89 2 2 2s2-.89 2-2s-.89-2-2-2m10-4v5h-2V4H4v2H2V1h2v2h16V1h2m-7 10.26V23h-2v-5h-2v5H9V11.26C6.93 10.17 5.5 8 5.5 5.5V5h2v.5C7.5 8 9.5 10 12 10s4.5-2 4.5-4.5V5h2v.5c0 2.5-1.43 4.67-3.5 5.76Z"
        />
      </svg>
    ),
    heading: "Proffesponal training plan",
    details:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut dolore facilisis.",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        // preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 16 16"
      >
        <path
          //   fill="currentColor"
          //   fill-rule="evenodd"
          d="M1.475 9C2.702 10.84 4.779 12.871 8 15c3.221-2.129 5.298-4.16 6.525-6H12a.5.5 0 0 1-.464-.314l-1.457-3.642l-1.598 5.593a.5.5 0 0 1-.945.049L5.889 6.568l-1.473 2.21A.5.5 0 0 1 4 9H1.475ZM.879 8C-2.426 1.68 4.41-2 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C11.59-2 18.426 1.68 15.12 8h-2.783l-1.874-4.686a.5.5 0 0 0-.945.049L7.921 8.956L6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.88Z"
        />
      </svg>
    ),
    heading: "Unique to your needs",
    details:
      "Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.",
  },
];
